<h2 mat-dialog-title>Удаление пользователя</h2>
<div mat-dialog-content>
  <p>Вы действительно хотите удалить пользователя?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Отмена</button>
  <button mat-button color="warn"
          cdkFocusInitial
          (click)="onSubmit()">Удалить
  </button>
</div>
